export default "__VITE_ASSET__SPM78Ui5__"